import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

export function FutureCapabilityModal({ open, onOpenChange, title, body }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="future-capability-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles size={16} className="text-coach-blue" />
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="text-[13.5px] text-carbon leading-relaxed" data-testid="future-capability-body">
          {body}
        </div>
        <div className="border-l-2 border-amber-hold bg-amber-hold/10 px-3 py-2 text-[12px] text-carbon mt-2">
          Requires production credentials + leadership approval.
          This is a demo — no external API calls are made.
        </div>
      </DialogContent>
    </Dialog>
  );
}
